import React, { useState } from 'react'
import { Col, Row } from 'reactstrap'
import { CustomButton } from 'styles/global'
import InputCustom from 'components/Inputs'
import ModalMargens from '../../../../components/ModalMargensInss'
import { CustomTitleCadastro } from 'views/cadastros/style'
import { FiInfo } from 'react-icons/fi'
import { Subtitle, InfoLink, InfoBox } from '../../style'
import * as profissionalActions from 'store/modules/cadastros/profissional/actions'
import useRedux from 'hooks/useRedux'
import { useSelector } from 'react-redux'
import aposentado from 'assets/images/cadastros/aposentado.png'
import { ApplicationState } from 'store'
import { PROFISSIONAL } from 'store/modules/cadastros/profissional/types'
import { STEPS_CADASTRO_APOSENTADO } from 'views/cadastros/constants/constants'
import Steps from 'components/Steps'
import SimpleCadastro from 'components/SimpleCadastro/SimpleCadastro'
import { margensSchema } from './constants/schema'
import { toast } from 'react-toastify'
import * as yup from 'yup'
import { maskMoney, removeMaskMoney } from 'util/masks'

const MargensDisponiveis = () => {
  const { margensDisponiveis } = useSelector<ApplicationState, PROFISSIONAL>(
    (state) => state.profissional
  )

  const { dispatch } = useRedux()
  const [modalOpen, setModalOpen] = useState(false)

  type MargensFields = keyof PROFISSIONAL['margensDisponiveis']
  const onChange = <T extends MargensFields>(
    value: T extends keyof PROFISSIONAL['margensDisponiveis']
      ? PROFISSIONAL['margensDisponiveis'][T]
      : never,
    field: T
  ) => {
    dispatch(profissionalActions.setAtualizarMargens(value, field))
  }
  function onSave() {
    dispatch(profissionalActions.cleanMargensInvalidas())

    margensSchema
      .validate(
        {
          margemConsignado: removeMaskMoney(
            margensDisponiveis.margemConsignado
          ),
          margemCartaoConsignado: removeMaskMoney(
            margensDisponiveis.margemCartaoConsignado
          ),
          margemCartaoBeneficio: removeMaskMoney(
            margensDisponiveis.margemCartaoBeneficio
          )
        },
        { abortEarly: false }
      )
      .then(() => {
        dispatch(profissionalActions.atualizarMargensSaga())
      })
      .catch((err) => {
        err.inner.forEach((e: yup.ValidationError) => {
          dispatch(
            profissionalActions.setMargensDisponiveisInvalid(
              {
                invalid: true,
                message: e.message
              },
              e.path as keyof PROFISSIONAL['margensDisponiveisInvalids']
            )
          )
        })
        toast.warn('Preencha todos os campos corretamente para salvar!')
      })
  }

  return (
    <SimpleCadastro
      banner={aposentado}
      title="Consulte suas margens no Meu INSS"
      subTitle="Para continuar, informe as margens disponíveis para empréstimo consignado, cartão consignado e cartão benefício.
Você pode encontrar essas informações no seu extrato de empréstimos no portal ou app Meu INSS."
    >
      <div className="container-fluid d-flex flex-column row-gap-20">
        <Steps steps={STEPS_CADASTRO_APOSENTADO} currentStep={4} />
        <Row className="justify-content-center">
          <Col>
            <CustomTitleCadastro>Margens Disponíveis</CustomTitleCadastro>
            <Subtitle>Informe suas margens para empréstimo e cartão</Subtitle>
          </Col>
        </Row>

        <Row className="justify-content-center mt-4">
          <Col md={8} className="text-center">
            <label className="label-14 d-block mb-2">Margem Consignado</label>
            <InputCustom
              type="text"
              placeholder="R$ 0,00"
              onChange={(e) => {
                onChange(maskMoney(e.target.value), 'margemConsignado')
              }}
              value={margensDisponiveis.margemConsignado ?? 0}
            />
          </Col>
        </Row>

        <Row className="justify-content-center">
          <Col md={8} className="text-center">
            <label className="label-14 d-block mb-2">
              Margem Cartão Consignado
            </label>
            <InputCustom
              type="text"
              placeholder="R$ 0,00"
              value={margensDisponiveis.margemCartaoConsignado ?? 0}
              onChange={(e) => {
                onChange(maskMoney(e.target.value), 'margemCartaoConsignado')
              }}
            />
          </Col>
        </Row>

        <Row className="justify-content-center">
          <Col md={8} className="text-center">
            <label className="label-14 d-block mb-2">
              Margem Cartão Benefício
            </label>
            <InputCustom
              type="text"
              placeholder="R$ 0,00"
              value={margensDisponiveis.margemCartaoBeneficio ?? 0}
              onChange={(e) => {
                onChange(maskMoney(e.target.value), 'margemCartaoBeneficio')
              }}
            />
          </Col>
        </Row>

        <Row className="justify-content-center">
          <Col md={8}>
            <InfoBox onClick={() => setModalOpen(true)}>
              <FiInfo size={18} />
              <InfoLink>Como consultar minhas margens no Meu INSS?</InfoLink>
            </InfoBox>
            <p className="text-center mt-2 text-size-12">
              Você encontra essas informações no seu extrato do INSS
            </p>
          </Col>
        </Row>

        <Row className="justify-content-center">
          <Col md={8}>
            <CustomButton
              background="var(--roxo-riber)"
              width="100%"
              padding="20"
              height="50px"
              borderRadius={21}
              onClick={() => {
                onSave()
              }}
            >
              AVANÇAR
            </CustomButton>
          </Col>
        </Row>

        {modalOpen && <ModalMargens onClose={() => setModalOpen(false)} />}
      </div>
    </SimpleCadastro>
  )
}

export default MargensDisponiveis
